import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { tyroHideModal } from '../../actions';
import TyroModalButtonGroup from './TyroModalButtonGroup';


class TyroModalError extends Component {
  constructor(props) {
    super(props);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  handleCloseClick() {
    const { tyroHideModal } = this.props;
    tyroHideModal();
  }

  render() {
    const { message = "" } = this.props;
    return (
      <div>
        <div className="ui basic segment marginless">
          <div className="ui error small message">
            <div className="header">
              Tyro has encountered an error
            </div>
            <p>{message}</p>
          </div>
        </div>
        <TyroModalButtonGroup>
          <div className="ui basic button" onClick={this.handleCloseClick}>Close</div>
        </TyroModalButtonGroup>
      </div>

    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    tyroHideModal
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(TyroModalError);